import { ImportType, importType } from "../../../server/repositories/aggregate-job/model";

export const isImportType = (value: unknown): value is ImportType => typeof value === "string" && value in importType;
